"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shouldPrintStopLabel = exports.buildStopLabelZpl = void 0;
// Label geometry: 76x51 mm @ 203 dpi (8 dots/mm) -> 608x408 dots.
const LABEL_WIDTH_DOTS = 608;
const LABEL_HEIGHT_DOTS = 408;
// Big centered numeral; top offset leaves vertical margin within the 408-dot label.
const FONT_HEIGHT_DOTS = 300;
const FONT_TOP_DOTS = 54;
// Builds the ZPL for a stop label: just the stop number, centered, big (max 3 chars).
const buildStopLabelZpl = ({ stop }) => '^XA' +
    `^PW${LABEL_WIDTH_DOTS}` +
    `^LL${LABEL_HEIGHT_DOTS}` +
    `^CF0,${FONT_HEIGHT_DOTS}` +
    `^FO0,${FONT_TOP_DOTS}^FB${LABEL_WIDTH_DOTS},1,0,C,0^FD${stop}^FS` +
    '^XZ';
exports.buildStopLabelZpl = buildStopLabelZpl;
// Gate: only the Wetaca source (1) and a real Optimo stop (>= 0). stop === -1 means the
// route was not uploaded to Optimo; Optimo customer stops start at 1.
const shouldPrintStopLabel = ({ sourceId, currentRoute }) => sourceId === 1 && (currentRoute?.stop ?? -1) >= 0;
exports.shouldPrintStopLabel = shouldPrintStopLabel;
//# sourceMappingURL=stop-label.js.map